import i18nRouteMeta from '@/app-core/mixins/i18n/i18nRouteMeta'
import {toLocaleUpperCase} from '@/app-core/lib/helpers'
import Translatable from '@/app-core/mixins/translatable'
import {getContrastColor} from '@/app-core/lib/utils/color'
import StoreCard from '@/app-theme/views/home/StoreCard.vue'
import StoreCommon from '@/app-core/mixins/store/storeCommon'

export default {
  name      : 'Category',
  components: {StoreCard},
  directives: {},
  mixins    : [i18nRouteMeta, Translatable, StoreCommon],
  props     : {},
  enums     : {},
  dataStore : {},
  data() {
    return {
      title      : '',
      description: '',
      category   : null,
      slug       : null,
      id         : null
    }
  },
  computed: {
    categoryStores() {
      return this.category ? this.AppStores.filter(store => parseInt(store.Category.Id) === parseInt(this.category.Id)) : []
    }
  },
  watch: {},
  beforeCreate() {
  },
  created() {
    this.$bus.$emit('cart:get-data')
    this.initView()
  },
  beforeMount() {
  },
  mounted() {
  },
  beforeUpdate() {
  },
  updated() {
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  methods: {
    getContrastColor,

    toLocaleUpperCase,

    initView() {
      this.slug = this.$route.params?.slug
      this.id = this.$route.params?.id

      this.category = this.AppCategories?.find(category => parseInt(category.Id) === parseInt(this.id))
      console.log(this.category)

      this.title = this.category?.Name || ''
      this.description = this.category?.Description || ''
    }
  }
}
